export const SOCIAL_FIELDS = [
  {
    label: 'Facebook',
    fieldKey: 'FACEBOOK',
  },
  {
    label: 'Instagram',
    fieldKey: 'INSTAGRAM',
  },
  {
    label: 'Youtube',
    fieldKey: 'YOUTUBE',
  },
  {
    label: 'Tiktok',
    fieldKey: 'TIKTOK',
  },
  // {
  //   label: 'LinkedIn',
  //   fieldKey: 'LINKEDIN',
  // },
  {
    label: 'Twitter',
    fieldKey: 'TWITTER',
  },
];
